module.exports = __webpack_public_path__ + "img/download-solid.df8c5fbf.svg";